module.exports = __webpack_public_path__ + "static/media/header_credit.92ffbd82.jpg";